import { ReactNode } from 'react';
import classNames from 'classnames';

interface EmptyProps {
  size?: 'normal' | 'small';
  children?: ReactNode;
}

export default function Empty({ children, size }: EmptyProps) {
  return (
    <div
      className={classNames('Empty', {
        'Empty--small': size === 'small',
      })}
    >
      <div className='Empty__icon' />
      {children && <p className='Empty__text'>{children}</p>}
    </div>
  );
}
